import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { fontSize, tabletMinWidth } from '../mixins';

const TimerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 11px 0;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 2;

  @media (min-width: 480px) {
    flex-direction: row;
    padding: 18px 0;
  }

  @media (min-width: 1280px) {
    padding: 31px 0;
  }
  
  &:after {
    content: '';
    display: block;
    width: 100vw;
    height: 100%;
    background-color: #E9F4FF;
    position: absolute;
    left: calc(-50vw + 50%);
    top: 0;
    z-index: -1;
    
    @media (min-width: 480px) {
      width: 80vw;
      left: calc(-40vw + 50%);
      border-radius: 12px;
    }

    @media (min-width: ${tabletMinWidth}px) {
      width: 582px;
      left: calc(50% - 291px);
    }
  }
`;

const TimerTitle = styled.div`
  font-weight: bold;
  ${fontSize(20)};
  line-height: 24px;
  color: #323232;
  letter-spacing: -0.2px;
  margin-bottom: 8px;

  @media (min-width: 480px) {
    margin: 0 16px 0 0;
  }
`;

const TimeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const TimeItem = styled.div`
  font-weight: bolder;
  ${fontSize(32)};
  line-height: 38px;
  color: #3393EC;
  position: relative;
  text-align: center;

  @media (min-width: 480px) {
    ${fontSize(24)};
    line-height: 28px;
  }

  span {
    font-weight: bolder;
    font-size: 14px;
    line-height: 17px;

    @media (min-width: 480px) {
      ${fontSize(12)};
      line-height: 14px;
    }
  }
`;

const TimeItemSep = styled.div`
  color: #3393EC;
  font-weight: normal;
  ${fontSize(20)};
  line-height: 24px;
  margin: 0 3px;
`;

const checkNumber = (value) => {
  value = value.toString();
  if (value.length === 1) {
    return `0${value}`;
  }
  return value;
};

const TimerShort = () => {
  const { t } = useTranslation();

  const [seconds, setSeconds] = useState(300);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds === 0) {
        clearInterval(interval);
        return;
      }
      setSeconds(seconds - 1);
    }, 1000);
    return () => clearInterval(interval);
  });

  const min = Math.floor(seconds / 60);
  const sec = seconds - min * 60;

  return (
    <TimerContainer>
      <TimerTitle>{t('today_only_sale')}</TimerTitle>
      <TimeWrapper>
        <TimeItem>
          {checkNumber(min)}
          <span>{t('minutes')}</span>
        </TimeItem>
        <TimeItemSep>:</TimeItemSep>
        <TimeItem>
          {checkNumber(sec)}
          <span>{t('seconds')}</span>
        </TimeItem>
      </TimeWrapper>
    </TimerContainer>
  );
};

export default TimerShort;
